import { Divider } from '@mui/material';
import Box from '@mui/material/Box';
import { useRecoilValue } from 'recoil';
import { selectedPatientIdState } from '~/state/atoms/patientAtoms';
import { currentStructureSetState } from '~/state/atoms/structureSet/structureSetAtoms';
import { WorkflowTypes } from '~/state/atoms/viewerAtoms';
import AiAssistantButton from '../../AiAssistantButton';
import StepHeader from '../StepHeader';
import EmptyStructureSet from './EmptyStructureSet/EmptyStructureSet';
import ImageHeader from './StructureSet/ImageHeader/ImageHeader';
import StructureSet from './StructureSet/StructureSet';

export default function ContouringContent() {
    const selectedPatientId = useRecoilValue(selectedPatientIdState);
    const currentStructureSet = useRecoilValue(currentStructureSetState);

    return (
        <Box height="100%" position="relative" display="grid">
            <Box position="relative" display="grid" gridTemplateRows="auto 1fr">
                <Box>
                    <StepHeader titleId="workflow.contouring" />
                    <Box px={1.5} my={1} mb={1.5}>
                        <AiAssistantButton page={WorkflowTypes.CONTOUR} />
                    </Box>
                    {!currentStructureSet && (
                        <>
                            <Divider
                                sx={{
                                    mx: 1.5,
                                    my: 1,
                                    fontSize: 11,
                                    color: 'text.secondary',
                                }}
                            >
                                OR
                            </Divider>
                            <EmptyStructureSet />
                        </>
                    )}
                    <Divider sx={{ mb: 1 }} />
                    <ImageHeader />
                </Box>
                {selectedPatientId && currentStructureSet && (
                    <Box
                        height="100%"
                        display="grid"
                        gridTemplateRows="auto 1fr"
                    >
                        <Divider sx={{ mb: 1, mt: 1.5 }} />
                        <StructureSet structureSet={currentStructureSet} />
                    </Box>
                )}
            </Box>
        </Box>
    );
}
